import { Platform } from 'react-native';
import { router } from 'expo-router';

/**
 * Where to go once a guest has signed in or registered: the screen that asked them to. Held in memory
 * only (the booking draft it belongs to lives in Redux for the same session), so an old value can never
 * outlive the app. Every "please sign in" button sets it, with null when there is nothing to return to,
 * so a prompt the user walked away from can't send a later sign-in somewhere unexpected.
 */
let pending: string | null = null;

export function setPostLoginRoute(route: string | null): void {
  pending = route;
}

/** Opens the app after a sign-in: Home, then (on top of it) the screen the user came from, if any. */
export function goAfterSignIn(): void {
  const route = pending;
  pending = null;
  // In a browser two navigations in the same moment drop the second one, so the way back to the booking never
  // happened. There the page just goes straight to it (the browser's Back button still returns to where they were).
  if (route && Platform.OS === 'web') {
    router.replace(route as never);
    return;
  }
  router.replace('/(tabs)');
  if (route) router.push(route as never);
}
